/* ============================================================
   kb-product.js — PDP behaviour for the kb-main-product section
   (variant accordions, swatches, upsells, carousel,
   delivery estimate, sticky ATC). Delegated on document so the
   section can re-render (theme editor) without rebinding.
   ============================================================ */
(function () {
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    return '£' + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* Normalise a size label to a UK bed keyword for the dimensions widget */
  function dimKey(s) {
    s = (s || '').toLowerCase();
    if (s.indexOf('super king') > -1) return 'super king';
    if (s.indexOf('small single') > -1) return 'small single';
    if (s.indexOf('small double') > -1) return 'small double';
    if (s.indexOf('single') > -1) return 'single';
    if (s.indexOf('double') > -1) return 'double';
    if (s.indexOf('king') > -1) return 'king';
    return '';
  }

  /* Sync a dimensions widget's size pills with the main product's selected size.
     Pass a scope (e.g. the open drawer) — innerHTML cloning drops JS-set radio
     state, so every freshly injected drawer body must be re-synced. */
  function syncDimWidget(scope) {
    var radios = $all('.dim-widget input[type="radio"]', scope || document);
    if (!radios.length) return;
    var selSize = '';
    $all('.product-option-wrapper[data-option-kind="size"] input[type="radio"]:checked', activeGroup()).forEach(function (r) {
      selSize = r.value || '';
    });
    var k = dimKey(selSize);
    if (!k) return;
    radios.forEach(function (r) {
      if (dimKey(r.dataset.dimValue) === k) r.checked = true;
    });
  }

  /* ---------- Cart bridge (uses kb.js helpers when present) ---------- */
  function rawAdd(items, btn) {
    if (window.KBCart && window.KBCart.addItems) return window.KBCart.addItems(items, btn);
    /* Fallback: same Section Rendering flow as kb.js */
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { console.error('Cart error:', data.message); return; }
        $all('.cart-count').forEach(function (b) { b.textContent = data.item_count > 0 ? data.item_count : ''; });
        if (data.sections && data.sections['cart-drawer']) {
          var tpl = document.createElement('div');
          tpl.innerHTML = data.sections['cart-drawer'];
          var fresh = tpl.firstElementChild;
          var current = $('#shopify-section-cart-drawer');
          if (fresh && current) current.replaceWith(fresh);
        }
        var d = $('#cartDrawer'), ov = $('#cartOverlay');
        if (d) { d.classList.add('open'); if (ov) ov.classList.add('show'); document.body.classList.add('cart-open'); }
      })
      .catch(console.error)
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }

  /* ---------- Variant state ----------
     All lookups are scoped to #product-variants so custom-option accordions
     (data-custom-product, one per metaobject product) are never mistaken for
     this product's own options. */
  function activeGroup() {
    return $('#product-variants') || document;
  }

  function getVariants(ctx) {
    var el = $('[data-variants-json]', ctx || activeGroup());
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function optionWrappers(ctx) {
    return $all('.product-option-wrapper[data-option-index]', ctx || activeGroup());
  }

  function selectedValues(ctx) {
    var vals = {};
    optionWrappers(ctx).forEach(function (w) {
      var checked = w.querySelector('input[type="radio"]:checked');
      vals[w.dataset.optionIndex] = checked ? checked.value : '';
    });
    return vals;
  }

  function findVariant(vals) {
    var list = getVariants();
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      var ok = true;
      for (var idx in vals) {
        if (vals[idx] === '') continue;
        if (v['option' + idx] !== vals[idx]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function variantMatches(vals, skipIdx, testIdx, testVal) {
    var list = getVariants();
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      var ok = true;
      for (var idx in vals) {
        if (idx === testIdx) {
          if (String(v['option' + idx]) !== String(testVal)) { ok = false; break; }
        } else if (String(idx) !== String(skipIdx) && vals[idx] !== '' && v['option' + idx] !== vals[idx]) {
          ok = false; break;
        }
      }
      if (ok && v.available) return true;
    }
    return false;
  }

  function markAvailability() {
    var vals = selectedValues();
    optionWrappers().forEach(function (w) {
      if (w.dataset.metaSwatches) return; /* metaobject colour list — not variant-driven */
      var idx = w.dataset.optionIndex;
      $all('input[type="radio"]', w).forEach(function (radio) {
        var selectable = variantMatches(vals, idx, idx, radio.value);
        var label = radio.nextElementSibling;
        if (label) label.classList.toggle('variant-label--unavailable', !selectable);
      });
    });
  }

  function applyVariant(v) {
    if (!v) return;
    $all('.variant-id-input').forEach(function (input) { input.value = v.id; });

    /* Prices — live total: this product's variant plus the selected variant
       of every custom-option group (configuration choices) */
    var extras = 0, extrasCompare = 0;
    customSelections().forEach(function (s) {
      extras += s.price;
      extrasCompare += s.compare > s.price ? s.compare : s.price;
    });
    var total = v.price + extras;
    var mainCompare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : null;
    var compare = mainCompare ? mainCompare + extrasCompare : (extrasCompare > extras ? v.price + extrasCompare : null);

    var priceEl = $('.js-product-price .price');
    if (priceEl) {
      priceEl.textContent = money(total);
      priceEl.setAttribute('data-price', total);
    }
    var priceBlock = $('.product__block--product_price');
    var nowTag = $('.js-product-price .price-now');

    if (compare) {
      if (priceBlock) priceBlock.classList.add('onsale');
      if (nowTag) nowTag.textContent = 'Now';
      var cmp = $('.js-compare-price');
      if (cmp) cmp.textContent = money(compare);
      $('.js-save-amount') && ($('.js-save-amount').textContent = money(compare - total));
      $('.js-save-percent') && ($('.js-save-percent').textContent = Math.round((compare - total) * 100 / compare) + '%');
    } else {
      if (priceBlock) priceBlock.classList.remove('onsale');
      if (nowTag) nowTag.textContent = '';
      var cmp2 = $('.js-compare-price');
      if (cmp2) cmp2.textContent = '';
      $('.js-save-amount') && ($('.js-save-amount').textContent = '');
      $('.js-save-percent') && ($('.js-save-percent').textContent = '');
    }

    /* ATC buttons */
    $all('[data-cart-add]').forEach(function (btn) {
      var priceSpan = btn.querySelector('.js-atc-price');
      if (priceSpan) priceSpan.textContent = money(total);
      var label = btn.querySelector('.btn-add-to-cart-text');
      btn.disabled = !v.available;
      if (label) {
        var custom = btn.dataset.atcLabel || 'Add to cart';
        label.textContent = v.available ? custom : 'Sold out';
      }
    });

    /* Klarna instalment price (total / 3) */
    var klarna = $('.js-klarna-price');
    if (klarna) klarna.textContent = money(Math.round(total / 3));

    /* Colour line-item property */
    var prop = $('.colour-property');
    var colourWrapper = $('.product-option-wrapper[data-option-kind="colour"]', activeGroup());
    if (prop && colourWrapper) {
      var checked = colourWrapper.querySelector('input[type="radio"]:checked');
      if (checked) prop.value = checked.dataset.label || checked.value;
    }

    /* Sync the dimensions widget pill with the selected size */
    syncDimWidget();

    /* Update URL (variant deep-link, no reload) — only when the product has
       options to pick; single-variant products leave the URL untouched */
    try {
      var g = activeGroup();
      if (!optionWrappers(g).length) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* noop */ }
  }

  function refreshVariant() {
    applyCustomGroupRules();
    applyCustomAvailability();
    markAvailability();
    var v = findVariant(selectedValues());
    if (v) applyVariant(v);
  }

  /* ---------- Custom product options (configuration groups) ----------
     Each [data-custom-product] accordion holds one metaobject product's
     variants as radio cards. The checked card of every group feeds the live
     price total and the multi-line Add to cart. */
  function customSelections() {
    var selections = $all('[data-custom-product]').map(function (w) {
      if (w.hidden) return null; /* group hidden by a visibility rule — not priced, not in cart */
      var radio = w.querySelector('input[type="radio"]:checked');
      if (!radio) return null;
      return {
        id: parseInt(radio.value, 10),
        title: radio.dataset.label || radio.value,
        price: parseInt(radio.dataset.price, 10) || 0,
        compare: parseInt(radio.dataset.comparePrice, 10) || 0,
        available: radio.dataset.available !== 'false'
      };
    }).filter(Boolean);
    /* Split-headboard add-on row rides along while toggled on */
    var splitRow = $('[data-split-addon]');
    if (splitRow && splitRow.classList.contains('is-added')) {
      var splitGroup = splitRow.closest('[data-custom-product]');
      if (!splitGroup || !splitGroup.hidden) {
        selections.push({
          id: parseInt(splitRow.dataset.variantId, 10) || 0,
          title: splitRow.dataset.title || 'Split Headboard',
          price: parseInt(splitRow.dataset.price, 10) || 0,
          compare: 0,
          available: true
        });
      }
    }
    return selections;
  }

  function applyCustomSelection(wrapper, radio) {
    radio.checked = true;
    var sel = wrapper.querySelector('.selected-option');
    if (sel) sel.textContent = radio.dataset.label || radio.value;
    var icon = wrapper.querySelector('.selected-icon');
    var srcIcon = radio.nextElementSibling && radio.nextElementSibling.querySelector('.variant-icon');
    if (icon && srcIcon && !icon.classList.contains('selected-icon--swatch')) {
      icon.innerHTML = '';
      icon.appendChild(srcIcon.cloneNode(true));
    }
  }

  /* Split-headboard add-on row: Add/Remove toggle — while on, its variant
     joins the live price total and the multi-line Add to cart */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-split-toggle]');
    if (!btn) return;
    var row = btn.closest('[data-split-addon]');
    if (!row) return;
    var added = row.classList.toggle('is-added');
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    btn.textContent = (btn.dataset.priceText ? '+ ' + btn.dataset.priceText + ' | ' : '') + (added ? 'Remove' : 'Add');
    refreshVariant();
  });

  /* Drawer variants that don't fit a 3ft Single base — hidden while Single is
     the selected size. Titles are matched on the leading name only (before the
     "- (£…)" price suffix) so price edits don't break the rule. */
  var SINGLE_DENY = ['2 drawers + 2 continental', '2 drawers foot end', '4 drawers'];

  /* Whole-group visibility rules between custom-option accordions: "show"
     (product title) is only rendered while "when.group" has "when.value"
     selected. Hidden groups drop out of the live total and the cart; their
     last selection is restored when they reappear. */
  var GROUP_RULES = [
    { show: 'storage options', when: { group: 'base options', value: 'solid base' } },
    { show: 'ottoman base', when: { group: 'base options', value: 'solid base' } }
  ];

  function normTitle(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function customCheckedLabel(name) {
    var found = '';
    $all('[data-custom-product]').some(function (w) {
      if (normTitle(w.dataset.productTitle) === name) {
        var r = w.querySelector('input[type="radio"]:checked');
        if (r) found = normTitle(r.dataset.label || r.value);
        return true;
      }
      return false;
    });
    return found;
  }

  function applyCustomGroupRules() {
    GROUP_RULES.forEach(function (rule) {
      var ok = customCheckedLabel(rule.when.group) === rule.when.value;
      $all('[data-custom-product]').forEach(function (w) {
        if (normTitle(w.dataset.productTitle) === rule.show) w.hidden = !ok;
      });
    });
  }

  function applyCustomAvailability() {
    var selSize = '';
    var sizeIdx = -1;
    var sizeWrapper = $('.product-option-wrapper[data-option-kind="size"]', activeGroup());
    if (sizeWrapper) {
      $all('input[type="radio"]', sizeWrapper).forEach(function (r, i) {
        if (r.checked) {
          selSize = r.value || '';
          sizeIdx = i;
        }
      });
    }
    var isSingle = dimKey(selSize) === 'single';
    $all('[data-custom-product]').forEach(function (w) {
      /* Ottoman Box: the Nth bed size takes the Nth box (titles differ only by
         price, so the mapping is positional). Exactly one card stays visible
         and auto-selected; clamped to the last box if sizes outnumber boxes. */
      var isOttomanBox = normTitle(w.dataset.productTitle) === 'ottoman box';
      /* Products tagged kidsbedswithsafetyrails: the "Solid Base" card is
         removed from the Base Options group (data attr set in Liquid). */
      var hideSolidBase = w.dataset.hideSolidBase === 'true' && normTitle(w.dataset.productTitle) === 'base options';
      var radios = $all('input[type="radio"]', w);
      var boxShow = -1;
      if (isOttomanBox && sizeIdx > -1 && radios.length) {
        boxShow = Math.min(sizeIdx, radios.length - 1);
      }
      var fallback = null;
      radios.forEach(function (radio, i) {
        var label = radio.nextElementSibling;
        var deny = isSingle && SINGLE_DENY.some(function (p) { return normTitle(radio.dataset.label || radio.value).indexOf(p) === 0; });
        if (hideSolidBase && normTitle(radio.dataset.label || radio.value) === 'solid base') deny = true;
        if (boxShow > -1) deny = i !== boxShow;
        if (label) label.classList.toggle('variant-label--hidden', deny);
        radio.disabled = deny;
        if (!deny && !fallback) fallback = radio;
      });
      /* selection just became hidden → fall back to the first allowed card */
      var checked = w.querySelector('input[type="radio"]:checked');
      if ((!checked || checked.disabled) && fallback) applyCustomSelection(w, fallback);
    });
  }

  /* ---------- Colour tooltip: flip to align-right when it would overflow the options column ---------- */
  function positionColourTooltip(label) {
    var tooltip = label.querySelector('.colour-tooltip');
    if (!tooltip) return;
    var rect = label.getBoundingClientRect();
    var tw = tooltip.offsetWidth || 164;
    var limit = window.innerWidth - 8;
    var cont = label.closest('.product-variants');
    var contLeft = 8;
    if (cont) {
      var cr = cont.getBoundingClientRect();
      limit = Math.min(limit, cr.right);
      contLeft = cr.left;
    }
    var overflowsRight = rect.left + tw > limit;
    var overflowsLeft = rect.right - tw < contLeft;
    tooltip.classList.toggle('align-right', overflowsRight && !overflowsLeft);
  }

  document.addEventListener('mouseover', function (e) {
    var label = e.target.closest('.accordion-colour-swatch');
    if (label) positionColourTooltip(label);
  });

  /* ---------- Add-on popup: variant <select> → live price + matched variant ---------- */
  function updateAddonPrice(popup, price, compare) {
    var priceEl = popup.querySelector('.js-upsell-price');
    if (priceEl) {
      var inner = priceEl.querySelector('.price') || priceEl;
      inner.textContent = money(price);
      priceEl.classList.toggle('sale', compare > price);
    }
    var cmpEl = popup.querySelector('.js-upsell-compare-at-price');
    if (cmpEl) cmpEl.hidden = !(compare > price);
    var saveWrap = popup.querySelector('.save-indication');
    if (saveWrap) {
      saveWrap.hidden = !(compare > price);
      if (compare > price) {
        var sv = popup.querySelector('.js-save-amount');
        var sp = popup.querySelector('.js-save-percent');
        if (sv) sv.textContent = money(compare - price);
        if (sp) sp.textContent = Math.round((compare - price) * 100 / compare) + '%';
      }
    }
  }

  /* Keep every add-on popup's size select in step with the active product's size */
  function syncAddonSizeSelections() {
    var selSize = '';
    $all('.product-option-wrapper[data-option-kind="size"] input[type="radio"]:checked', activeGroup()).forEach(function (r) {
      selSize = r.value || '';
    });
    var k = dimKey(selSize);
    if (!k) return;
    $all('.upsell-popup select.upsell-select').forEach(function (sel) {
      var best = null;
      Array.prototype.forEach.call(sel.options, function (o) {
        if (!best && dimKey(o.textContent) === k) best = o;
      });
      if (best && sel.value !== best.value) {
        sel.value = best.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.tagName === 'SELECT' && t.classList.contains('upsell-select')) {
      var apop = t.closest('.upsell-popup');
      if (apop) {
        var aopt = t.options[t.selectedIndex];
        if (aopt) {
          updateAddonPrice(apop, parseInt(aopt.dataset.price, 10) || 0, parseInt(aopt.dataset.comparePrice, 10) || 0);
          apop.dataset.matchedVariantId = aopt.value;
          delete apop.dataset.matchedVariantTitle;
        }
      }
      return;
    }

    var radio = t;
    if (radio.type !== 'radio') return;

    /* Custom product-option accordion: a variant card was picked — update the
       group's summary (icon + title) and recompute the live total */
    var customWrap = radio.closest('[data-custom-product]');
    if (customWrap) {
      applyCustomSelection(customWrap, radio);
      refreshVariant();
      return;
    }

    /* Meta-driven colour accordion has no data-option-index — match it too */
    var wrapper = radio.closest('.product-option-wrapper[data-option-index], .product-option-wrapper[data-meta-swatches]');
    if (wrapper) {
      var label = radio.dataset.label || radio.value;
      var sel = wrapper.querySelector('.selected-option');
      if (sel) sel.textContent = label;

      if (wrapper.dataset.optionKind === 'colour') {
        var fill = wrapper.querySelector('.selected-swatch-fill');
        if (fill) {
          if (radio.dataset.swatchImage) {
            fill.style.background = 'url("' + radio.dataset.swatchImage + '") center center / cover no-repeat';
          } else {
            fill.style.background = radio.dataset.hex || '#ccc';
          }
        }
        var colourProp = $('.colour-property');
        if (colourProp) colourProp.value = label;
      } else {
        var icon = wrapper.querySelector('.selected-icon');
        var srcIcon = radio.nextElementSibling && radio.nextElementSibling.querySelector('.variant-icon');
        if (icon && srcIcon && !icon.classList.contains('selected-icon--swatch')) {
          var keep = icon.querySelector('.selected-swatch-fill');
          icon.innerHTML = '';
          icon.appendChild(srcIcon.cloneNode(true));
        }
      }
      refreshVariant();
      if (wrapper.dataset.optionKind === 'size') {
        syncAddonSizeSelections();
        syncDimWidget($('.pdp-tab-drawer.open'));
      }
      return;
    }

    /* Upsell popup variant radios → live price */
    var popup = radio.closest('.upsell-popup');
    if (popup) {
      var json = popup.querySelector('[data-upsell-variants]');
      if (!json) return;
      var variants;
      try { variants = JSON.parse(json.textContent); } catch (err) { return; }
      var vals = {};
      $all('input[type="radio"]:checked', popup).forEach(function (r) {
        var m = r.name.match(/^upsell-(.+)-(\d+)$/);
        if (m) vals[m[2]] = r.value;
      });
      var found = null;
      variants.forEach(function (v) {
        var ok = true;
        for (var idx in vals) { if (v['option' + idx] !== vals[idx]) { ok = false; break; } }
        if (ok) found = v;
      });
      if (found) {
        var priceOut = popup.querySelector('.js-upsell-price');
        if (priceOut) priceOut.textContent = money(found.price);
        popup.dataset.matchedVariantId = found.id;
        popup.dataset.matchedVariantTitle = found.title !== 'Default Title' ? found.title : '';
      }
    }
  });

  /* ---------- Upsell select / change / remove ---------- */
  function applyUpsellSelection(popup, wrap) {
    if (!popup || !wrap) return;
    var vid = popup.dataset.matchedVariantId || popup.dataset.defaultVariantId;
    var selected = wrap.querySelector('[data-selected-upsell]');
    if (vid && selected) selected.dataset.variantId = vid;
    var qtyInput = popup.querySelector('.quantity-value');
    if (qtyInput && selected) {
      selected.dataset.quantity = String(Math.max(1, parseInt(qtyInput.value, 10) || 1));
    }
    var nameOut = wrap.querySelector('.js-selected-upsell-name');
    if (nameOut) nameOut.textContent = popup.dataset.matchedVariantTitle || popup.dataset.productTitle || nameOut.textContent;
    var priceOut = wrap.querySelector('.js-selected-upsell-price');
    if (priceOut) {
      var psrc = popup.querySelector('.js-upsell-price');
      priceOut.textContent = psrc ? psrc.textContent.trim() : '';
    }
    wrap.classList.add('has-selection');
  }

  document.addEventListener('click', function (e) {
    /* "View X Info" — open the side drawer with the product's details */
    var viewInfo = e.target.closest('.view-info[data-drawer-key]');
    if (viewInfo) {
      e.preventDefault();
      e.stopPropagation();
      openPdpDrawer(viewInfo.dataset.drawerKey);
      /* Refresh the drawer's price/size row from the matching popup */
      var dbody = document.querySelector('.pdp-tab-drawer [data-pdp-drawer-body]');
      var dbtn = dbody && dbody.querySelector('[data-upsell-direct]');
      var dpop2 = dbtn && document.getElementById(dbtn.dataset.upsellDirect);
      if (dpop2) {
        var dsel = dpop2.querySelector('select.upsell-select');
        var dprice = dbody.querySelector('.js-addon-drawer-price');
        var dsize = dbody.querySelector('.js-addon-drawer-size');
        var dsrc = dpop2.querySelector('.js-upsell-price');
        if (dprice && dsrc) dprice.textContent = dsrc.textContent.trim();
        if (dsize) dsize.textContent = dsel ? dsel.options[dsel.selectedIndex].textContent : '';
      }
      return;
    }

    /* Generic popover opener (kept for any [data-popup-open] trigger) */
    var popOpen = e.target.closest('[data-popup-open]');
    if (popOpen) {
      var popTarget = document.getElementById(popOpen.dataset.popupOpen);
      if (popTarget && popTarget.showPopover) popTarget.showPopover();
      return;
    }

    /* Add-on direct add (row click or drawer "Choose size") — select size-matched (or default) variant */
    var directBtn = e.target.closest('[data-upsell-direct]');
    if (directBtn) {
      var dpop = document.getElementById(directBtn.dataset.upsellDirect);
      applyUpsellSelection(dpop, dpop ? dpop.closest('[data-upsell-wrapper]') : null);
      if (directBtn.closest('.pdp-tab-drawer')) closePdpDrawer();
      return;
    }

    /* Add-on popup quantity stepper */
    var qbtn = e.target.closest('.upsell-popup .quantity-btn');
    if (qbtn) {
      var qinput = qbtn.closest('.upsell-popup').querySelector('.quantity-value');
      if (qinput) {
        var qv = parseInt(qinput.value, 10) || 1;
        qinput.value = Math.max(1, qv + (qbtn.classList.contains('quantity-plus') ? 1 : -1));
      }
      return;
    }

    var confirmBtn = e.target.closest('[data-upsell-confirm]');
    if (confirmBtn) {
      var popup = confirmBtn.closest('.upsell-popup');
      var wrap = popup.closest('[data-upsell-wrapper]');
      applyUpsellSelection(popup, wrap);
      if (popup.hidePopover) popup.hidePopover();
      return;
    }

    var changeBtn = e.target.closest('[data-upsell-change]');
    if (changeBtn) {
      var wrap2 = changeBtn.closest('[data-upsell-wrapper]');
      if (wrap2) {
        wrap2.classList.remove('has-selection');
        var det2 = wrap2.querySelector('details');
        if (det2) det2.open = true;
      }
      return;
    }

    var removeBtn = e.target.closest('[data-upsell-remove]');
    if (removeBtn) {
      var wrap3 = removeBtn.closest('[data-upsell-wrapper]');
      if (wrap3) {
        wrap3.classList.remove('has-selection');
        var sel3 = wrap3.querySelector('[data-selected-upsell]');
        if (sel3) sel3.dataset.variantId = '';
      }
    }
  });

  /* Stash the upsell product title + default variant on each popup for the confirm handler */
  function stampPopups() {
    $all('[data-upsell-wrapper]').forEach(function (wrap) {
      var selEl = wrap.querySelector('[data-selected-upsell]');
      $all('.upsell-popup', wrap).forEach(function (popup) {
        var titleEl = popup.querySelector('.upsell-popup__title');
        if (titleEl) popup.dataset.productTitle = titleEl.textContent.trim();
        if (!popup.dataset.defaultVariantId) {
          var jsonEl = popup.querySelector('[data-upsell-variants]');
          if (jsonEl && jsonEl.dataset.defaultVariantId) {
            popup.dataset.defaultVariantId = jsonEl.dataset.defaultVariantId;
          } else if (selEl && selEl.dataset.defaultVariantId) {
            popup.dataset.defaultVariantId = selEl.dataset.defaultVariantId;
          }
        }
      });
    });
  }

  /* ---------- Add to cart ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var form = $('.product-form');
    var idInput = form && form.querySelector('.variant-id-input');
    var id = idInput ? idInput.value : (btn.dataset.variantId || '');
    if (!id) return;

    var main = { id: parseInt(id, 10), quantity: 1 };
    var colourProp = form && form.querySelector('.colour-property');
    if (colourProp && colourProp.value) {
      var m = colourProp.name.match(/properties\[(.*)\]/);
      if (m) { main.properties = {}; main.properties[m[1]] = colourProp.value; }
    }

    var items = [main];

    /* Custom-option selections ride along as cart lines, tagged with the
       bed's variant id so the cart nests them under the bed ("Included
       with Your Bed"). Only opt-out labels ("No Drawers", "No Storage"…)
       stay out — £0 picks like "Standard 54 Inch" DO go in the cart. */
    customSelections().forEach(function (s) {
      var label = (s.title || '').trim().toLowerCase();
      if (label === 'no' || label.indexOf('no ') === 0) return;
      items.push({ id: s.id, quantity: 1, properties: { '_main-variant': id } });
    });

    $all('[data-upsell-wrapper].has-selection').forEach(function (wrap) {
      var sel = wrap.querySelector('[data-selected-upsell]');
      if (sel && sel.dataset.variantId) {
        /* Mattress / headboard add-ons nest under the bed like the options */
        items.push({ id: parseInt(sel.dataset.variantId, 10), quantity: Math.max(1, parseInt(sel.dataset.quantity, 10) || 1), properties: { '_main-variant': id } });
      }
    });

    btn.disabled = true;
    btn.classList.add('is-loading');
    rawAdd(items, btn).then(function () {
      if (window.KBCart && window.KBCart.openCart) window.KBCart.openCart();
      btn.classList.add('is-success');
      setTimeout(function () { btn.classList.remove('is-success'); }, 1800);
    });
  });

  /* ---------- Carousel + lightbox ---------- */
  var swipeMoved = false;

  function goToSlide(i) {
    var track = $('[data-carousel-track]');
    if (!track) return;
    var slides = $all('.carousel__slide', track);
    if (!slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.style.transform = 'translateX(-' + (i * 100) + '%)';
    track.dataset.current = i;
    $all('.carousel__pagination-dot').forEach(function (d) {
      var active = parseInt(d.dataset.slideIndex, 10) === i;
      d.classList.toggle('active', active);
      d.setAttribute('aria-current', active ? 'true' : 'false');
    });
    $all('.thumbnail-item').forEach(function (t) {
      t.classList.toggle('active', parseInt(t.dataset.slideIndex, 10) === i);
    });
    var prev = $('[data-carousel-prev]'), next = $('[data-carousel-next]');
    if (prev) prev.classList.toggle('is-disabled', i === 0);
    if (next) next.classList.toggle('is-disabled', i === slides.length - 1);
  }

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-carousel-prev]');
    var next = e.target.closest('[data-carousel-next]');
    var dot = e.target.closest('.carousel__pagination-dot');
    var thumb = e.target.closest('.thumbnail-item');
    if (!prev && !next && !dot && !thumb) return;

    var track = $('[data-carousel-track]');
    var current = track ? parseInt(track.dataset.current || '0', 10) : 0;
    if (prev) goToSlide(current - 1);
    else if (next) goToSlide(current + 1);
    else goToSlide(parseInt((dot || thumb).dataset.slideIndex, 10));
  });

  /* Touch/mouse swipe — a real swipe also suppresses the lightbox click */
  document.addEventListener('pointerdown', function (e) {
    var container = e.target.closest('[data-carousel-container]');
    if (!container) return;
    var startX = e.clientX;
    var track = container.querySelector('[data-carousel-track]');
    swipeMoved = false;
    function onMove(ev) {
      if (Math.abs(ev.clientX - startX) > 10) swipeMoved = true;
    }
    function onUp(ev) {
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      var dx = ev.clientX - startX;
      if (track && Math.abs(dx) > 45) {
        var current = parseInt(track.dataset.current || '0', 10);
        goToSlide(current + (dx < 0 ? 1 : -1));
        swipeMoved = true;
      }
    }
    document.addEventListener('pointermove', onMove);
    document.addEventListener('pointerup', onUp);
  });

  /* Lightbox */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.lightbox-trigger');
    if (trigger) {
      if (swipeMoved) return;
      var lb = $('.pdp-lightbox');
      var img = lb && lb.querySelector('[data-lightbox-img]');
      if (!lb || !img) return;
      var slideImg = trigger.querySelector('img');
      img.src = trigger.dataset.lightboxSrc || (slideImg ? slideImg.src : '');
      img.alt = slideImg ? slideImg.alt : '';
      lb.hidden = false;
      requestAnimationFrame(function () { lb.classList.add('open'); });
      document.body.classList.add('pdp-lightbox-open');
      return;
    }
    if (e.target.closest('[data-lightbox-close]') || e.target.classList.contains('pdp-lightbox')) {
      closeLightbox();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
    var vi = e.target.closest && e.target.closest('.view-info[data-drawer-key]');
    if (vi && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      openPdpDrawer(vi.dataset.drawerKey);
    }
  });
  function closeLightbox() {
    var lb = $('.pdp-lightbox');
    if (!lb || lb.hidden) return;
    lb.classList.remove('open');
    document.body.classList.remove('pdp-lightbox-open');
    setTimeout(function () { lb.hidden = true; }, 250);
  }

  /* ---------- Delivery popup ---------- */
  function initDeliveryPopup(root) {
    var wrap = $('.delivery-popup-wrapper', root);
    if (!wrap) return;
    var autoClose = parseInt(wrap.dataset.autoClose, 10) || 0;
    var closed = false;
    try { closed = sessionStorage.getItem('pdp-delivery-popup-closed') === 'true'; } catch (e) { /* noop */ }

    if (closed) { wrap.classList.remove('initally-hidden'); wrap.classList.add('hide-popup'); return; }

    setTimeout(function () { wrap.classList.remove('initally-hidden'); }, 1000);
    if (autoClose > 0) {
      setTimeout(function () { wrap.classList.add('hide-popup'); }, autoClose);
    }
    var closeBtn = wrap.querySelector('.delivery-popup__close');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      wrap.classList.add('hide-popup');
      try { sessionStorage.setItem('pdp-delivery-popup-closed', 'true'); } catch (e) { /* noop */ }
    });
  }

  /* ---------- Delivery date estimate (bank-holiday aware) ---------- */
  function pad2(n) { return n < 10 ? '0' + n : '' + n; }
  function isoDate(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }

  function easterSunday(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }
  function firstMonday(year, month) {
    var d = new Date(year, month - 1, 1);
    var add = d.getDay() === 0 ? 1 : 8 - d.getDay();
    return new Date(year, month - 1, add);
  }
  function lastMonday(year, month) {
    var last = new Date(year, month, 0);
    var sub = last.getDay() === 0 ? 0 : last.getDay();
    return new Date(year, month - 1, last.getDate() - sub);
  }
  function bankHolidays(year) {
    var h = [];
    var nyd = new Date(year, 0, 1);
    h.push(year + '-01-' + pad2(nyd.getDay() === 0 ? 2 : nyd.getDay() === 6 ? 3 : 1));
    var easter = easterSunday(year);
    h.push(isoDate(new Date(easter.getTime() - 2 * 864e5))); /* Good Friday */
    h.push(isoDate(new Date(easter.getTime() + 864e5)));     /* Easter Monday */
    h.push(isoDate(firstMonday(year, 5)));
    h.push(isoDate(lastMonday(year, 5)));
    h.push(isoDate(lastMonday(year, 8)));
    var xmas = new Date(year, 11, 25), boxing = new Date(year, 11, 26);
    h.push(year + '-12-' + pad2(xmas.getDay() === 0 || xmas.getDay() === 6 ? 27 : 25));
    h.push(year + '-12-' + pad2(boxing.getDay() === 0 || boxing.getDay() === 6 ? 28 : 26));
    return h;
  }
  function addWorkingDays(start, days) {
    var d = new Date(start);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6 && bankHolidays(d.getFullYear()).indexOf(isoDate(d)) === -1) added++;
    }
    return d;
  }
  function formatDeliveryDate(d) {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var day = d.getDate();
    var suffix = day >= 11 && day <= 13 ? 'th' : day % 10 === 1 ? 'st' : day % 10 === 2 ? 'nd' : day % 10 === 3 ? 'rd' : 'th';
    return days[d.getDay()] + ' ' + day + suffix + ' ' + months[d.getMonth()];
  }
  function fillDeliveryDates(root) {
    var els = $all('.delivery-date', root);
    if (!els.length) return;
    var lead = parseInt(root.dataset.leadDays, 10) || 0;
    var parts = (root.dataset.cutoff || '11:00').split(':');
    var cutH = parseInt(parts[0], 10), cutM = parseInt(parts[1], 10);
    var now = new Date();
    var pastCutoff = now.getHours() > cutH || (now.getHours() === cutH && now.getMinutes() >= cutM);
    var date = addWorkingDays(now, lead + (pastCutoff ? 1 : 0));
    var text = formatDeliveryDate(date);
    els.forEach(function (el) { el.textContent = text; });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky() {
    var sticky = $('[data-sticky-atc]');
    var mainBtn = $('.product-form [data-cart-add]');
    if (!sticky || !mainBtn) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var mainTop = mainBtn.getBoundingClientRect().top;
        var foot = document.querySelector('footer');
        var footTop = foot ? foot.getBoundingClientRect().top : Infinity;
        /* Visible only between the main ATC scrolling away and the footer
           arriving — so it never sits on top of the lower sections/footer */
        var on = mainTop < 0 && footTop > window.innerHeight - 8;
        sticky.classList.toggle('active', on);
        /* sticky-atc-on + --sticky-atc-h lift the fabs (.to-top / .nl-fab) clear of the bar */
        document.body.classList.toggle('sticky-atc-on', on);
        document.body.style.setProperty('--sticky-atc-h', sticky.offsetHeight + 'px');
        document.body.style.paddingBottom = on ? sticky.offsetHeight + 'px' : '';
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Info tab side drawer (full content per tab) ---------- */
  function openPdpDrawer(key) {
    var drawer = $('.pdp-tab-drawer');
    var content = key && $('[data-drawer-content="' + key + '"]');
    if (!drawer || !content) return;
    var body = drawer.querySelector('[data-pdp-drawer-body]');
    var title = drawer.querySelector('[data-pdp-drawer-title]');
    if (body) body.innerHTML = content.innerHTML;
    /* innerHTML clone drops JS-set radio state — re-sync the size pills to the
       main product's current selection */
    if (body) syncDimWidget(drawer);
    if (title) title.textContent = content.dataset.drawerTitle || '';
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pdp-drawer-open');
    $all('.prod-section[data-drawer-key="' + key + '"] .prod-section-title').forEach(function (row) {
      row.setAttribute('aria-expanded', 'true');
    });
    drawer.querySelector('[data-pdp-drawer-close]').focus();
  }

  function closePdpDrawer() {
    var drawer = $('.pdp-tab-drawer');
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pdp-drawer-open');
    $all('.prod-section-title[aria-expanded="true"]').forEach(function (row) {
      row.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var row = e.target.closest('.prod-section-title');
    if (row) {
      var section = row.closest('.prod-section');
      if (section && section.dataset.drawerKey) openPdpDrawer(section.dataset.drawerKey);
      return;
    }
    if (e.target.closest('[data-pdp-drawer-close]') || e.target.closest('[data-pdp-drawer-overlay]')) {
      closePdpDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePdpDrawer();
    var row = e.target.closest && e.target.closest('.prod-section-title');
    if (row && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      var section = row.closest('.prod-section');
      if (section && section.dataset.drawerKey) openPdpDrawer(section.dataset.drawerKey);
    }
  });

  /* ---------- Init ---------- */
  function init() {
    var root = $('[data-pdp]');
    if (!root || root.dataset.kbInit === 'true') return;
    root.dataset.kbInit = 'true';

    stampPopups();
    fillDeliveryDates(root);
    initDeliveryPopup(root);
    initSticky();
    if ($('[data-variants-json]')) refreshVariant();
    syncAddonSizeSelections();
    goToSlide(0);

    /* Single-image products: no carousel chrome */
    var slides = $all('.carousel__slide');
    if (slides.length < 2) {
      var dotsWrap = $('.carousel__pagination');
      if (dotsWrap) dotsWrap.style.display = 'none';
      var prevBtn = $('[data-carousel-prev]');
      var nextBtn = $('[data-carousel-next]');
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor section re-render: re-init without double-binding */
  document.addEventListener('shopify:section:load', init);

  window.KBProduct = { init: init };
})();
